import { useField } from 'formik';
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { CircularProgress, Grid, TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useDebounce } from '@sierralabs/react-material-ui';
const StyledGrid = styled(Grid) `
  display: flex;
  flex-direction: column;
  .select-field {
    margin-right: 22px;
  }
  .MuiAutocomplete-root {
    display: flex;
    flex-direction: column;
  }
`;
export const FormikAutocomplete = props => {
    let { onSearch, onChange, onBlur, options, loading, freeSolo, name, label, getOptionDisabled, getOptionSelected, getOptionLabel, getSelectedValue = (option) => option, // default to return option object
    filterOptions, disabled, grid } = props;
    // Create a ref that store the onSearch handler
    const onSearchRef = useRef(onSearch);
    const mountedRef = useRef(false);
    const freeSoloTimeoutRef = useRef();
    // Update ref.current value if handler changes.
    // This allows our effect below to always get latest handler ...
    // ... without us needing to pass it in effect deps array ...
    // ... and potentially cause effect to re-run every render.
    if (!getSelectedValue) {
        // default to return option object
        getSelectedValue = (option) => option;
    }
    const [field, meta, { setValue, setTouched }] = useField(name);
    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState(field.value);
    const [forceSearch, setForceSearch] = useState(false);
    const debouncedSearch = useDebounce(search ? search : '', 300);
    useEffect(() => {
        var _a;
        // mountedRef so that we don't onSearch on mount
        if (forceSearch || mountedRef.current) {
            (_a = onSearchRef.current) === null || _a === void 0 ? void 0 : _a.call(onSearchRef, debouncedSearch);
            setForceSearch(false);
        }
        else {
            mountedRef.current = true;
        }
    }, [debouncedSearch, forceSearch]);
    if (!grid) {
        // default field to expand entire width of form
        grid = { xs: 12 };
    }
    return (React.createElement(StyledGrid, Object.assign({ item: true, className: 'formik-autocomplete' }, grid),
        React.createElement(Autocomplete, { open: open, 
            // debug
            value: field.value, freeSolo: freeSolo, onOpen: () => setOpen(true), onClose: () => setOpen(false), getOptionDisabled: getOptionDisabled, getOptionSelected: getOptionSelected, getOptionLabel: getOptionLabel, filterOptions: filterOptions, options: options, loading: loading, disabled: disabled, onInputChange: (event, value, reason) => {
                setSearch(value);
            }, onBlur: field.onBlur, onChange: (event, value) => {
                if (onChange) {
                    onChange(value);
                }
                if (getSelectedValue && value) {
                    setValue(getSelectedValue(value));
                    // field.onChange(event);
                }
                setTouched(true);
            }, renderInput: params => (React.createElement(TextField, Object.assign({}, params, { label: label, variant: 'outlined', autoComplete: 'new-password', InputProps: Object.assign(Object.assign({}, params.InputProps), { autoComplete: 'new-password', endAdornment: (React.createElement(React.Fragment, null,
                        loading ? (React.createElement(CircularProgress, { color: 'inherit', size: 20 })) : null,
                        params.InputProps.endAdornment)) }), error: meta.touched && Boolean(meta.error), helperText: meta.error, onKeyPress: (event) => event.key === 'Enter' && setForceSearch(true), onChange: event => {
                    if (freeSolo) {
                        event.persist();
                        clearTimeout(freeSoloTimeoutRef.current);
                        freeSoloTimeoutRef.current = setTimeout(() => {
                            event.target.name = name;
                            field.onChange(event);
                            setTouched(false);
                        }, 300);
                    }
                }, onBlur: event => onBlur === null || onBlur === void 0 ? void 0 : onBlur(event) }))) })));
};
export default FormikAutocomplete;
//# sourceMappingURL=FormikAutocomplete.js.map